// extracted by mini-css-extract-plugin
module.exports = {"form":"header-module--form--bEWU0","collapse":"header-module--collapse--WV3rg"};